import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AssemblyGroup } from '@paragon/contract-library';

interface AssemblyGroupsState {
  readonly status: 'loading' | 'loaded' | 'catastrophicallyFailed';
  readonly data: Record<string, AssemblyGroup>;
}

const initialState: AssemblyGroupsState = {
  status: 'loading',
  data: {},
};

export const assemblyGroupsSlice = createSlice({
  name: 'assemblyGroups',
  initialState,
  reducers: {
    loadedAssemblyGroup: (state, action: PayloadAction<AssemblyGroup>) => {
      state.data[action.payload.guid] = action.payload;
    },

    loadedFromServer(state, action: PayloadAction<readonly AssemblyGroup[]>) {
      state.status = 'loaded';

      for (const assemblyGroup of action.payload) {
        state.data[assemblyGroup.guid] = assemblyGroup;
      }
    },

    loadingCatastrophicallyFailed(state) {
      state.status = 'catastrophicallyFailed';
    },

    singleAssemblyGroupEdited(state, action: PayloadAction<AssemblyGroup>) {
      state.data[action.payload.guid] = action.payload;
    },

    singleAssemblyGroupArchived(state, action: PayloadAction<string>) {
      delete state.data[action.payload];
    },
  },
});
